(() => {
  const setup = () => {
    document.querySelectorAll('.galrie-customer-reviews').forEach(section => {
      // Product links retain the full native review; unavailable products and store reviews remain labels.
      const productRoot = section.dataset.productRoot || '/products/';
      section.querySelectorAll('.jdgm-carousel-item__product').forEach(link => {
        const href = link.getAttribute('href') || '';
        if (href.startsWith('/products/')) {
          link.setAttribute('href', productRoot + href.slice('/products/'.length));
        } else if (!href.startsWith(productRoot)) {
          link.removeAttribute('href');
          link.removeAttribute('tabindex');
        }
      });
      const prev = section.querySelector('.jdgm-carousel__left-arrow');
      const next = section.querySelector('.jdgm-carousel__right-arrow');
      [[prev, section.dataset.previousLabel], [next, section.dataset.nextLabel]].forEach(([button, label]) => {
        if (button && label) { button.setAttribute('role', 'button'); button.setAttribute('aria-label', label); }
      });
      const details = section.querySelector('.galrie-customer-reviews__product');
      const reviewToken = new URLSearchParams(location.search).get('judgeme_token');
      if (details) {
        details.hidden = !reviewToken;
        if (reviewToken) details.open = true;
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  window.addEventListener('hashchange', setup);
  document.addEventListener('shopify:section:load', setup);
})();

